<ws-modal-wrapper headerLabel="Expense Detail" cancelLabel="Close" [hideSave]="true" [loading]="loading" (cancel)="close()">
    @if (!loading && accrualDetail && accrualDetail.accrualDetailRows.length === 0) {
        <div class="h2" style="text-align: center;">
            No accrual details to show
        </div>
    }
    @if (!loading && accrualDetail && accrualDetail.accrualDetailRows.length > 0) {
        <div class="accrual-detail">
            <div style="display: flex; justify-content: space-between;">
                <div class="first-column">
                    <div>
                        <label>Collector:</label>
                        <span>{{ accrualDetail.collector }}</span>
                    </div>
                    <div>
                        <label>Bill Type:</label>
                        <span>{{ accrualDetail.isRecurring ? 'Recurring' : 'One Time' }}</span>
                    </div>
                    <div>
                        <label>Amount:</label>
                        <span>{{ accrualDetail.taxAmount | currency: 'USD':'symbol-narrow' }}</span>
                    </div>
                </div>
                <div class="second-column">
                    <div style="display: flex;">
                        <label>Tax Period:</label>
                        <weissman-datetime [readOnly]="true" [(inputDate)]="accrualDetail.taxPeriodBeginDate" [dateOnly]="true">
                        </weissman-datetime>
                        -
                        <weissman-datetime [readOnly]="true" [(inputDate)]="accrualDetail.taxPeriodEndDate"
                                           [dateOnly]="true"></weissman-datetime>
                    </div>
                    @if (accrualDetail.accrualsBeginDate) {
                        <div style="display: flex;">
                            <label>Accruals Begin:</label>
                            <weissman-datetime [(inputDate)]="accrualDetail.accrualsBeginDate" [dateOnly]="true" [readOnly]="true"></weissman-datetime>
                        </div>
                    }
                </div>
            </div>
            <div class="overflow-x-auto">
                @if (accrualDetail) {
                    <table class="table table-condensed accrual-detail-table">
                        <thead>
                        <tr>
                            <th style="text-align: left;">Acct. Period</th>
                            <th style="text-align: center;">Duration</th>
                            <th>Tax Amount</th>
                            <th>Base Expense</th>
                            <th style="width: 111px;">True Up (Dn)</th>
                            <th>Period Expense</th>
                            <th>Total Expensed</th>
                            <th>Remaining</th>
                            <th>Payment Amt</th>
                            @if (showBalances) {
                                <th>Prepaid Balance</th>
                            }
                            @if (showBalances) {
                                <th>Payable Balance</th>
                            }
                            @if (editMode) {
                                <th></th>
                            }
                        </tr>
                        </thead>
                        <tbody>
                            @for (row of accrualDetail.accrualDetailRows; track row; let i = $index) {
                                <tr [class.not-actual-no-hover]="row.isProjected"
                                    (mouseenter)="row.isHovered = true"
                                    (mouseleave)="row.isHovered = false;">
                                    <td style="text-align: left;">{{ row.accountingPeriodName }}</td>
                                    <!-- regular row -->
                                    @if (!row.isReconcileRow) {
                                        <td style="text-align: center;" helpTooltip [tooltipText]="getDateRange(row)" position="top">{{ row.durationText }}</td>
                                    }
                                    @if (!row.isReconcileRow) {
                                        <td>
                                            <parenthetical-currency [value]="row.taxAmount"></parenthetical-currency>
                                        </td>
                                    }
                                    @if (!row.isReconcileRow) {
                                        <td>
                                            <parenthetical-currency [value]="row.baseExpense"></parenthetical-currency>
                                        </td>
                                    }
                                    <!-- ----- -->
                                    <!-- adjustment row -->
                                    @if (row.isReconcileRow) {
                                        <td colspan="3" style="text-align: left;">
                                            @if (!(row.isEditAdjustment || row.isAddAdjustment)) {
                                                <span>Adjustment - {{ row.reconcileDescription }}</span>
                                            }
                                            @if (row.isEditAdjustment || row.isAddAdjustment) {
                                                <input type="text" class="form-control" maxlength="100"
                                                       [(ngModel)]="row.reconcileDescription" placeholder="Adjustment Description">
                                            }
                                        </td>
                                    }
                                    <!-- ----- -->
                                    <td [class.overridden]="row.trueUpOverridden" style="position: relative; width: 111px;">
                                        @if (!(row.isEditAdjustment || row.isAddAdjustment || row.isEditOverridden)) {
                                            <parenthetical-currency [value]="row.trueUp"></parenthetical-currency>
                                        }
                                        @if (row.isHovered && row.trueUpOverridden && !currentlyEditing && editMode) {
                                            <button class="ace-btn has-icon btn-primary btn-danger" (click)="revertTrueUp(row)"
                                                    style="margin: 0; position:absolute; top: 5px; right: -25px; bottom: 5px;"
                                            >
                                                <i class="fa fa-undo"></i>
                                            </button>
                                        }
                                        @if (row.isEditAdjustment || row.isAddAdjustment || row.isEditOverridden) {
                                            <input type="text" class="form-control text-end" style="display: inline-block; width: 100px"
                                                   [(ngModel)]="row.trueUp" [min]="0"
                                                   currencyMask [options]="{ allowNegative: true, precision: 2 }">
                                        }
                                    </td>
                                    <td>
                                        <parenthetical-currency [value]="row.periodExpense"></parenthetical-currency>
                                    </td>
                                    <td>
                                        <parenthetical-currency [value]="row.totalExpensed"></parenthetical-currency>
                                    </td>
                                    <td>
                                        <parenthetical-currency [value]="row.remaining"></parenthetical-currency>
                                    </td>
                                    <td>
                                        <parenthetical-currency [value]="row.paymentAmount"></parenthetical-currency>
                                    </td>
                                    @if (showBalances) {
                                        <td>
                                            <parenthetical-currency [value]="row.prepaidBalance"></parenthetical-currency>
                                        </td>
                                    }
                                    @if (showBalances) {
                                        <td>
                                            <parenthetical-currency [value]="row.payableBalance"></parenthetical-currency>
                                        </td>
                                    }
                                    @if (editMode) {
                                        <td>
                                            @if (!row.isReconcileRow && !row.isEditOverridden) {
                                                <div class="btn-group" dropdown
                                                     [class.invisible]="!row.isHovered || currentlyEditing">
                                                    <button id="button-basic" dropdownToggle type="button" class="ace-btn btn-sm dropdown-toggle"
                                                            style="margin: 0;" (click)="setupRowMenu(row, i)"
                                                            aria-controls="dropdown-basic">
                                                        <i class="fa fa-ellipsis-h"></i>
                                                    </button>
                                                    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                                                        @for (item of rowMenuItems; track item) {
                                                            <li role="menuitem" [class.disabled]="item.value == AccrualRowActionEnum.NoAction">
                                                                <a
                                                                    class="dropdown-item pointer" (click)="performRowAction(row, item, i)">{{ item.name }}</a>
                                                            </li>
                                                        }
                                                    </ul>
                                                </div>
                                            }
                                            @if (row.isEditAdjustment || row.isAddAdjustment || row.isEditOverridden) {
                                                <div style="white-space: nowrap;">
                                                    <button class="ace-btn has-icon btn-sm btn-primary"
                                                            [disabled]="row.trueUp == null || (row.isReconcileRow && !row.reconcileDescription)"
                                                            style="margin: 0;"
                                                            (click)="saveAdjustment(row, i)">
                                                        <i class="fa fa-save"></i>
                                                    </button>
                                                    <button class="ace-btn has-icon btn-sm btn-primary btn-danger"
                                                            style="margin: 0;"
                                                            (click)="cancelAdjustment(row)">
                                                        <i class="fa fa-close"></i>
                                                    </button>
                                                </div>
                                            }
                                            @if (row.isReconcileRow && !currentlyEditing) {
                                                <div style="white-space: nowrap;" [class.invisible]="!row.isHovered">
                                                    <button class="ace-btn has-icon btn-sm btn-primary" style="margin: 0;" (click)="editAdjustment(row)">
                                                        <i class="fa fa-pencil"></i>
                                                    </button>
                                                    <button class="ace-btn has-icon btn-sm btn-primary btn-danger" style="margin: 0;" (click)="deleteAdjustment(row, i)">
                                                        <i class="fa fa-trash"></i>
                                                    </button>
                                                </div>
                                            }
                                        </td>
                                    }
                                </tr>
                            }
                        </tbody>
                    </table>
                }
            </div>
            <div style="display: flex; justify-content: space-between;">
                <div style="display: flex; align-items: center;">
                    <label style="margin-bottom: 0; margin-right: 5px;">Adjustments:</label>
                    <select class="form-select form-select-sm" [(ngModel)]="accrualDetail.accrualAdjustmentMethod" (change)="updateAccrual()" [disabled]="!editMode">
                        <option [ngValue]="2">Amortize</option>
                        <option [ngValue]="1">Single Period</option>
                    </select>
                </div>
                <div style="display: flex; flex-direction: column;">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" [(ngModel)]="accrualDetail.fullyExpenseNext" (change)="updateAccrual()" [disabled]="!editMode">
                            Fully expense in next
                            available accounting period
                        </label>
                    </div>
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" [(ngModel)]="showBalances" (change)="updateShowBalances()">
                            Show Accrual Balances
                        </label>
                    </div>
                </div>
            </div>
        </div>
    }
</ws-modal-wrapper>
